var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66333 15.2518C9.12913 15.6652 9.96568 15.9996 10.9995 15.9996C12.0333 15.9996 12.8699 15.6652 13.3356 15.2518L14.6633 16.7475C13.7609 17.5485 12.4192 17.9996 10.9995 17.9996C9.5798 17.9996 8.23803 17.5485 7.33565 16.7475L8.66333 15.2518Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7497 7.49982L21.7497 7.30064L19.7497 3.80064L19.7497 0.749817L2.24971 0.749818L2.24971 3.80064L0.249712 7.30064L0.249712 7.49982C0.249712 8.48436 0.629125 9.38028 1.24971 10.0494L1.24971 20.2744C1.24971 20.8129 1.68623 21.2494 2.22471 21.2494L19.7747 21.2494C20.3132 21.2494 20.7497 20.8129 20.7497 20.2744L20.7497 10.0494C21.3703 9.38028 21.7497 8.48436 21.7497 7.49982ZM18.7997 11.1643C18.5419 11.2203 18.2743 11.2498 17.9997 11.2498C16.7349 11.2498 15.6164 10.6237 14.9372 9.66442C14.6959 9.94101 14.4136 10.1791 14.1082 10.3781C13.1986 10.9711 12.0501 11.2498 10.9997 11.2498C9.94932 11.2498 8.80083 10.9711 7.8912 10.3781C7.58585 10.1791 7.30356 9.94101 7.06227 9.66442C6.38305 10.6237 5.26451 11.2498 3.99971 11.2498C3.72515 11.2498 3.45749 11.2203 3.19971 11.1643L3.19971 19.2994L18.7997 19.2994L18.7997 11.1643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStores);
export default __webpack_public_path__ + "static/media/stores.b361f2663d586eeac828fa153df0faf6.svg";
export { ForwardRef as ReactComponent };